import { AsyncThunk } from '@reduxjs/toolkit';

import { withMandant } from '../../../../../shared/thunks/with-mandant/with-mandant.thunk';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';
import { statisticsDataMock } from '../mocks/statistics-all-data.mock';
import { StatisticsModel } from '../models/statistics.model';
import { mapToTableStatisticsData } from '../utils/mapping/mapping.util';
import { GetStatisticsPathParams } from './models/get-statistics-path-params.model';

// TODO: UNCOMMENT AFTER BE IMPLEMENTATION
export const getStatistics: AsyncThunk<
  StatisticsModel[],
  GetStatisticsPathParams,
  Record<string, unknown>
> = withMandant<GetStatisticsPathParams, StatisticsModel[]>(
  Endpoints.GET_STATISTICS,
  'statistics/get-statistics',
  async () =>
    /* { args , endpoint }*/
    {
      await new Promise<void>(resolve => setTimeout(resolve, 1000));
      // const queryParams = createQueryParams({
      //   appId: args.appId,
      //   size: args.pagination?.size ?? PaginationDefaults.size,
      //   offset: args.pagination?.offset ?? PaginationDefaults.offset,
      // });
      //
      // const { data }: AxiosResponse<StatisticsDto[]> = await axiosInstance.get(
      //   endpoint + queryParams
      // );

      return mapToTableStatisticsData(statisticsDataMock);
    }
);
